// VAPID Public Key из sw.js
const VAPID_PUBLIC_KEY = 'BLpofeVrXs37QO2ndhRYtswpuPb9F7c35NnlnUQex3gL4XIwAL_Fn-Uf8qN4PBqLqL4DkiZ8UG8TuzrB2bq5Kf8';

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function requestPushNotificationPermission(clientId?: number): Promise<boolean> {
  try {
    // Проверяем, поддерживаются ли уведомления
    if (!('Notification' in window)) {
      console.log('[Push] Notifications not supported');
      return false;
    }

    // Проверяем, не запрашивали ли уже
    const hasAskedPermission = localStorage.getItem('push-permission-asked');
    if (hasAskedPermission === 'true') {
      console.log('[Push] Already asked, skipping');
      return false;
    }

    // Проверяем текущий статус
    if (Notification.permission === 'granted') {
      console.log('[Push] Already granted');
      localStorage.setItem('push-permission-asked', 'true');
      return false;
    }

    if (Notification.permission === 'denied') {
      console.log('[Push] Already denied');
      localStorage.setItem('push-permission-asked', 'true');
      return false;
    }

    console.log('[Push] Requesting permission...');

    // Запрашиваем разрешение (требуется user gesture)
    const permission = await Notification.requestPermission();
    console.log('[Push] Permission result:', permission);

    // Сохраняем флаг что уже запрашивали
    localStorage.setItem('push-permission-asked', 'true');

    if (permission === 'granted') {
      console.log('[Push] Permission granted, subscribing to push...');

      // Получаем Service Worker registration
      const registration = await navigator.serviceWorker.ready;
      console.log('[Push] Service Worker ready');

      // Подписываемся на push уведомления
      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
      });

      console.log('[Push] Subscription created:', subscription);
      console.log('[Push] Sending subscription with clientId:', clientId);

      // Отправляем подписку на сервер с clientId
      const response = await fetch('/api/push/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          subscription,
          clientId
        })
      });

      if (response.ok) {
        console.log('[Push] Subscription sent to server');

        // Показываем тестовое уведомление
        registration.showNotification('Level Sport Club', {
          body: 'Уведомления успешно включены! Теперь вы не пропустите важные события.',
          icon: '/logotype-white.png',
          badge: '/logotype-white.png'
        });

        return true;
      } else {
        console.error('[Push] Failed to send subscription to server:', response.status);
        return false;
      }
    }

    return false;
  } catch (error) {
    console.error('[Push] Error enabling notifications:', error);
    return false;
  }
}

export async function requestMicrophonePermission(): Promise<boolean> {
  try {
    // Проверяем, не запрашивали ли уже
    const hasAskedMic = localStorage.getItem('microphone-permission-asked');
    if (hasAskedMic === 'granted') {
      console.log('[Mic] Already granted, skipping');
      return true;
    }

    if (hasAskedMic === 'denied') {
      console.log('[Mic] Previously denied, skipping');
      return false;
    }

    console.log('[Mic] Requesting microphone permission...');

    // Запрашиваем доступ к микрофону (требуется user gesture)
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: {
        channelCount: 1,
        echoCancellation: true,
        noiseSuppression: true
      }
    });

    console.log('[Mic] Permission granted');

    // Сохраняем что разрешение получено
    localStorage.setItem('microphone-permission-asked', 'granted');

    // Сразу останавливаем stream - нам нужно было только разрешение
    stream.getTracks().forEach(track => track.stop());

    return true;
  } catch (error) {
    console.log('[Mic] Permission denied or error:', error);
    // Сохраняем что было отклонено
    localStorage.setItem('microphone-permission-asked', 'denied');
    return false;
  }
}

export { VAPID_PUBLIC_KEY };
